import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import { getUpcomingTeamEvents, startEditingEvent } from 'actions/Event';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HideInPercy from 'components/HideInPercy';
import { faCog, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { RoleHelper } from '@shoflo/polymer/helpers/RoleHelper/RoleHelper';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

const StyledUncontrolledDropdown = styled(UncontrolledDropdown)`
  max-width: calc(100% - 50px);
`;

const StyledHeader = HideInPercy(styled.span`
  color: #333333;
  font-size: 28px;
  font-weight: bold;
  padding: 8px 0;

  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`);

const StyledDropdownToggle = styled(DropdownToggle)`
  padding-left: 0;
  padding-bottom: 10px;

  @media only screen and (max-width: 768px) {
    padding-bottom: 0;
    line-height: 18px;
  }
`;

const StyledDropdownItem = styled(DropdownItem)`
  max-width: 250px;

  &.disabled {
    cursor: not-allowed !important;

    span,
    svg {
      color: #ccc;
    }
  }
`;

const StyledLink = styled(Link)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  margin-left: 6px;
  transform: translateY(-2px);

  path {
    stroke-width: 30;
    stroke: black;
  }
`;

const StyledDivider = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 0.25rem 1rem;
`;

const StyledSettingsIcon = styled(FontAwesomeIcon)`
  display: inline-block;
  margin-right: 8px;
`;

const Unconnected = ({
  events,
  event,
  getUpcomingTeamEvents,
  startEditingEvent,
  user
}) => {
  const { teamId } = useParams();

  useEffect(() => {
    getUpcomingTeamEvents();
  }, [teamId, getUpcomingTeamEvents, user]);

  if (!event) return null;

  const items = events
    ? events.map(evt => {
        return (
          <StyledDropdownItem key={`event-dropdown-item-${evt._id}`}>
            <StyledLink to={`/dash/team/${evt.team}/event/${evt._id}`}>
              {evt.title}
            </StyledLink>
          </StyledDropdownItem>
        );
      })
    : null;

  const isPastEvent = event && event.endOn < moment().valueOf();

  const isEventAdmin = RoleHelper.hasEventAdminRole(user, teamId, event._id);

  if (!isEventAdmin) return <StyledHeader>{event.title}</StyledHeader>;

  return (
    <StyledUncontrolledDropdown>
      <StyledDropdownToggle nav data-testid="eventDashDropdown">
        <StyledHeader>
          {event.title}{' '}
          {isEventAdmin && <StyledFontAwesomeIcon icon={faChevronDown} />}
        </StyledHeader>
      </StyledDropdownToggle>
      <DropdownMenu end>
        <StyledDropdownItem
          data-testid="eventSettingsDropdownItem"
          disabled={isPastEvent}
          onClick={() => (isPastEvent ? null : startEditingEvent(event))}
        >
          <StyledSettingsIcon icon={faCog} />
          <span>Event Settings</span>
        </StyledDropdownItem>
        {items && items.length ? <StyledDivider /> : null}
        {items}
      </DropdownMenu>
    </StyledUncontrolledDropdown>
  );
};

const PropMapper = ({ teamEvents, event, user }) => {
  return { events: teamEvents, event, user };
};

export { PropMapper, Unconnected };

export default withRouter(
  connect(PropMapper, {
    getUpcomingTeamEvents,
    startEditingEvent
  })(Unconnected)
);
